import { FX30_ETHERNET, IP_ADDRESS } from '../constants';
import sortBy from 'lodash/sortBy';
import { ConfigTree } from '../types/device';

export function getDeviceInfoFromMasterData(deviceInfo: any[]): any {
    const blueprintVersion = deviceInfo.map((device) => device.blueprintVersion);
    const latestBlueprint = Math.max.apply(0, blueprintVersion).toString();
    return deviceInfo.find((x) => x.blueprintVersion === latestBlueprint);
}

export function sortByChildDeviceCount(deviceInfo: any[]): any {
    const deviceBlueprints = deviceInfo.map((device) => {
        device.deviceCount = device.deviceID.split(',').length;
        return device;
    });

    const sortDeviceData = sortBy(deviceBlueprints, 'deviceCount')[0];
    return getDeviceInfoFromMasterData(sortDeviceData.value);
}

export const getExistingChildDevices = (configTreeJson: ConfigTree): any[] => {
    let childDeviceList: any[] = [];
    if (configTreeJson) {
            childDeviceList = configTreeJson.childDevices;
    }
    return childDeviceList;
};

export const getExistingChildDevicesUnitId = (configTreeJson: any, model?: string): any[] => {
    let unitIdchildList: any[] = [];
    let childDeviceList = getExistingChildDevices(configTreeJson);
    if (childDeviceList.length > 0) {
        if (model) {
            childDeviceList = childDeviceList.filter((x: any) => x.model === model);
        }
        unitIdchildList = childDeviceList.map((x: any) => x.modbusaddr.unitid);
    }
    return unitIdchildList;
};

export const IPAddressValidation = (parentModelType: string, ipAddress: string): boolean => {
    if (parentModelType.toLowerCase() === FX30_ETHERNET && !IP_ADDRESS.test(ipAddress)) return false;
    return true;
};

export const getChildDeviceLimit = (
    selectedObj: any
): { allowedCreation: number; allowedUnitIdDulipcate: number } | undefined => {
    if (
        selectedObj &&
        Object.prototype.hasOwnProperty.call(selectedObj.value, 'allowedCreation') &&
        Object.prototype.hasOwnProperty.call(selectedObj.value, 'allowedUnitIdDulipcate')
    ) {
        return {
            allowedCreation: parseInt(selectedObj.value.allowedCreation),
            allowedUnitIdDulipcate: parseInt(selectedObj.value.allowedUnitIdDulipcate),
        };
    }
};
